import React from 'react'
import classNames from 'classnames'
import tinycolor from 'tinycolor2'
import './PickerSwatch.scss'

const PickerSwatch = ({ color, onClick, alpha }) => {
  return (
    <div
      style={{ backgroundColor: color }}
      className={classNames('viso-color-picker-swatch', onClick && 'viso-color-picker-swatch--click')}
      onClick={() => {
        if (!onClick) return
        const tc = tinycolor(color)
        const rgb = tc.toRgb()
        const updatedRgb = { ...rgb, a: alpha ?? rgb.a }
        const tcWithAlpha = tinycolor(updatedRgb)

        onClick({
          hex: tcWithAlpha.toHex8String(),
          rgb: updatedRgb,
          hsl: tcWithAlpha.toHsl(),
          hsv: tcWithAlpha.toHsv()
        })
      }}
    />
  )
}

export default PickerSwatch
